<template>
  <h3 
    class="header" 
    v-html="title"/>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';

.header {
  color: $color-navy-50;
  font-size: px-to-rem(24px);
  font-weight: bold;
}

section > h3 {
  margin-top: 16px;
}
</style>
